import { api } from './api';

export const agentsService = {
  getAgents: async () => {
    const response = await api.get('/agents/');
    return response.data;
  },

  getAgentById: async (agentId) => {
    const response = await api.get(`/agents/${agentId}`);
    return response.data;
  },

  createAgent: async (data) => {
    const response = await api.post('/agents/', data);
    return response.data;
  },

  updateAgent: async (agentId, data) => {
    const response = await api.put(`/agents/${agentId}`, data);
    return response.data;
  },

  deleteAgent: async (agentId) => {
    await api.delete(`/agents/${agentId}`);
  },

  chatWithAgent: async (agentId, message, tenantId) => {
    const response = await api.post(`/agents/${agentId}/chat`, {
      user_input: message,
      tenant_id: tenantId,
    });
    return response.data;
  },

  assignAgentToTenant: async (agentId, tenantId, aiProviderId, aiModelId) => {
    const response = await api.post(
      `/agents/${agentId}/assign-to-tenant/${tenantId}`,
      { ai_provider_id: aiProviderId, ai_model_id: aiModelId }
    );
    return response.data;
  },
};